module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-news/master-news.component.scss
// module id = ./src/app/master/master-news/master-news.component.scss
// module chunks = main